import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'Date'
})
export class DatePipe implements PipeTransform {
  transform(value: any, args?: any): any {
    return new Date(value);
  }
}
